import React from "react";
import { useParams } from "react-router-dom";
import { Space, Typography } from "antd";
import { DollarCircleOutlined } from "@ant-design/icons";
import { InstructionsPaymentCard } from "./InstructionsPaymentCard";
import { GetnetCard } from "./GetnetCard";
import { MercadoPagoCard } from "./MercadoPagoCard";
import { FiservCard } from "./FiservCard";

const { Title } = Typography;

export const PaymentConfigList: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const sellerCode = decodeURIComponent(id ?? "");

  return (
    // Sin padding propio: el layout ya lo pone, y con el de acá el título quedaba más abajo que en
    // el resto de las páginas (xcons-docs#509).
    <div>
      {/* El ícono del menú, como el resto de los títulos de página. */}
      <Space align="center" style={{ marginBottom: 20 }}>
        <DollarCircleOutlined style={{ fontSize: 22 }} />
        <Title level={3} style={{ margin: 0 }}>
          Configuración de pagos — {sellerCode}
        </Title>
      </Space>

      <FiservCard sellerCode={sellerCode} />
      <MercadoPagoCard sellerCode={sellerCode} />
      <GetnetCard sellerCode={sellerCode} />

      <InstructionsPaymentCard
        sellerCode={sellerCode}
        code="bank-transfer"
        cardTitle="Transferencia bancaria"
        helpText="datos para que el cliente realice la transferencia"
      />
      <InstructionsPaymentCard
        sellerCode={sellerCode}
        code="check-money"
        cardTitle="Pago en efectivo / contra entrega"
      />
      <InstructionsPaymentCard
        sellerCode={sellerCode}
        code="purchase-order"
        cardTitle="Orden de compra (Purchase Order)"
        helpText="instrucciones para emitir orden de compra"
      />
    </div>
  );
};
